export default {"src":"/_next/static/media/adversarial-attack-simulation.4e31b5cc.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};